import { Box, HStack, Text } from '@chakra-ui/react';

import { CssTooltip } from '@app/components/atoms/css-tooltip';
import { AccommodationTileAmenitiesStaticProps } from '@app/components/molecules/accommodation-tile';
import {
    amenityBoxStyles,
    getOverflowWord,
} from '@app/helpers/accommodation-tile-amenities.helpers';
import { getAmenityIcon } from '@app/helpers/get-amenity-icon';

export const AccommodationTileAmenitiesStatic = ({
    sortedAmenities,
    maxVisible,
    getAmenityLabel,
    translations,
    ...rest
}: AccommodationTileAmenitiesStaticProps) => {
    const visibleAmenities = sortedAmenities.slice(0, maxVisible);
    const hiddenCount = sortedAmenities.length - maxVisible;

    return (
        <HStack as={'ul'} flexWrap={'wrap'} gap={2} {...rest}>
            {visibleAmenities.map((amenity, index) => {
                const icon = getAmenityIcon(amenity.type, {
                    fontSize: 'md',
                    css: { '--icon-stroke': 1 },
                });

                return (
                    <HStack
                        as={'li'}
                        key={`amenity-${amenity.type}-${index}`}
                        {...amenityBoxStyles}
                        px={{ base: 0, md: amenityBoxStyles.pl }}
                        w={{ base: 6, md: 'auto' }}
                        justify={{ base: 'center', md: 'flex-start' }}
                        data-testid={`acc-tile-amenity-${amenity.type}`}
                    >
                        {icon}
                        <Text
                            as={'span'}
                            fontSize={'xs'}
                            whiteSpace={'nowrap'}
                            display={{ base: 'none', md: 'block' }}
                        >
                            {getAmenityLabel(amenity)}
                        </Text>
                    </HStack>
                );
            })}

            {hiddenCount > 0 && (
                <Box as={'li'} hideBelow={'md'}>
                    <CssTooltip
                        zIndex={'overLinkOverlay'}
                        content={
                            <Box>
                                {sortedAmenities.slice(maxVisible).map((amenity, i) => (
                                    <Box key={i}>{getAmenityLabel(amenity)}</Box>
                                ))}
                            </Box>
                        }
                        tooltipProps={{ hideBelow: 'md' }}
                    >
                        <HStack fontSize={'xs'} {...amenityBoxStyles} px={2} textWrap={'nowrap'}>
                            <Box as={'span'} userSelect={'none'}>
                                +{hiddenCount} {getOverflowWord(hiddenCount, translations)}
                            </Box>
                        </HStack>
                    </CssTooltip>
                </Box>
            )}
        </HStack>
    );
};
